<template>
  <el-popover
    v-model="visible"
    popper-class="service-float-popover"
    placement="left"
    width="190"
    trigger="manual"
  >
    <div class="content">
      <div v-if="!isJPSite" class="flex-start" @click="() => handleClick()">
        <a href="https://ockcsim.sf-express.com/webchat_new/static/html/index.html?ht=kGhpmZ" target="_blank" rel="noopener noreferrer">
          <div>
            <p>{{ $t('standard.eParcel') }}</p>
            <p>{{ $t('standard.overseasFulfilment') }}</p>
            <p>{{ $t('standard.warehouse') }}</p>
          </div>
        </a>
      </div>
      <div v-if="showLinkUrl" class="flex-start" @click="() => linkUrl()">
        <div class="link-url">
          <div>
            <p>{{ $t('standard.standardExpress') }}</p>
            <p>{{ $t('standard.economyExpress') }}</p>
            <p>{{ $t('standard.heavyFreight') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference" v-drag class="float-wrapper" :class="{ isZH: ['zh-CN', 'zh-HK'].includes(language) }" @click="() => handleClick()">
      <img class="icon" src="./imgs/service_online.svg" alt="">
      <span class="service-text" v-html="$t('standard.onlineService')" />
    </div>
  </el-popover>
</template>

<script>
import { mapGetters } from 'vuex'
// import { getHuanXinUrl } from '@/utils'
import { getDictionaryApi } from '@/api/common/public'

let thisRef = null
export default {
  directives: {
    drag: (el) => {
      const dragBox = el
      let disX
      let disY
      dragBox.onmousedown = e => {
        disX = e.clientX - dragBox.offsetLeft
        disY = e.clientY - dragBox.offsetTop
      }
      document.onmousemove = e => {
        if (!disX && !disY) return
        const left = e.clientX - disX
        const top = e.clientY - disY
        dragBox.style.left = left + 'px'
        dragBox.style.top = top + 'px'
        thisRef && (thisRef.isDrag = true)
      }
      document.onmouseup = e => {
        // document.onmousemove = null
        // document.onmouseup = null
        if (thisRef && thisRef.isDrag) {
          e.stopPropagation()
          e.preventDefault()
        }
        disX = null
        disY = null
        thisRef && (thisRef.isDrag = false)
      }
    }
  },
  data() {
    return {
      el: null,
      visible: false,
      isDrag: false,
      serviceUrl: null
    }
  },
  computed: {
    ...mapGetters(['siteCode', 'language', 'floatServiceClickStatus']),
    isJPSite() {
      return this.siteCode === 'JP'
    },
    _linkUrl() {
      if (['HK', 'MO', 'CN', 'TW'].includes(this.siteCode)) {
        if (this.siteCode === 'CN' && ['zh-CN', 'zh-HK'].includes(this.language)) {
          return 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=523&clientType=1&accountId='
        } else if (['HK', 'MO'].includes(this.siteCode) && ['zh-CN', 'zh-HK', 'en'].includes(this.language)) {
          const map = {
            'zh-CN': 528,
            'zh-HK': 315,
            'en': 942
          }
          return `https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=${map[this.language]}&clientType=2&accountId=`
        } else if (this.siteCode === 'TW' && ['zh-CN', 'zh-HK', 'en'].includes(this.language)) {
          return 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=882&clientType=1&accountId='
        } else {
          return ''
        }
      } else {
        // url = getHuanXinUrl(this.language)
        return ''
      }
    },
    showLinkUrl() {
      return (this.serviceUrl && this.serviceUrl.length > 0) || this._linkUrl
    }
  },
  watch: {
    'siteCode'(val) {
      if (val) {
        this.fetchServiceUrl()
      }
    }
  },
  mounted() {
    thisRef = this
  },
  methods: {
    async fetchServiceUrl() {
      if (['HK', 'MO', 'CN', 'TW'].includes(this.siteCode)) return false
      // debugger
      getDictionaryApi({
        name: 'serviceUrl',
        key: this.siteCode,
        lang: this.language,
        enDefaultFlag: false
      }).then(response => {
        if (response && response.data) {
          this.serviceUrl = response?.data?.[this.siteCode?.toString()?.toUpperCase()] || ''
        }
      })
    },
    linkUrl() {
      this.visible = !this.visible
      const name = this.$route.name
      if ((name === 'OrderEdit' || name === 'OrderAdd') && this.isJPSite) {
        this.$store.dispatch('app/setFloatServiceClickStatus', !this.floatServiceClickStatus)
      } else {
        console.log('%c Line:143 🥓', 'color:#2eafb0')
        if (!this.showLinkUrl) return
        window.open(this._linkUrl || this.serviceUrl)
      }
    },
    handleClick() {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.float-wrapper {
  position: fixed;
  width: 48px;
  height: 100px;
  padding-top: 48px;
  padding-bottom: 16px;
  right: 37px;
  bottom: 120px;
  background: $color01;
  border-radius: 24px;
  box-shadow: 0 6px 10px -10px rgba(0,0,0,0.10), 0 3px 12px 0 rgba(0,0,0,0.06);
  z-index: 201;
  user-select: none;
  &.isZH {
    height: 136px;
  }
  .icon {
    position: absolute;
    width: 36px;
    height: 36px;
    left: 6px;
    top: 6px;
    pointer-events: none;
  }
  .service-text {
    display: block;
    color: #FF3A3A;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    line-height: 18px;
  }
}

.content {
  a {
    width: 100%;
    display: flex;
    align-items: center;
    color: $color02;
  }
  > div {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 8px;
    margin: 0 0 16px 0;
    border-radius: 6px;
    font-size: 16px;
    color: $color02;
    font-weight: 500;

    &.flex-start {
      align-items: flex-start;
    }
    &::before {
      position: absolute;
      top: -8px;
      left: 0;
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      background: $color04;
    }

    &:first-child {
      &::before {
        display: none;
      }
    }

    &:last-child {
      margin-bottom: 8px;
    }

    &:hover {
      cursor: pointer;
      background: rgba(255,142,155,0.16);
    }

    p {
      margin: 0;
      padding: 3px 0;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
.link-url {
  width: 100%;
}
</style>

<style>
.service-float-popover {
  padding: 8px 12px 0;
  border: none;
  z-index: 201 !important;
}
</style>
